import { EditorInputProps } from "@/components/module-api-editor/types";
import { SchemaQuickEditor } from "@/components/schema-quick-editor";

export function SchemaQuickViewer({
  path,
  title,
  value,
  onChange: _onChange,
}: {
  path: string;
  title: string;
} & EditorInputProps) {
  return (
    <SchemaQuickEditor
      path={path}
      title={title}
      allowTopLevelReferences={false}
      value={value}
      onChange={() => undefined}
      workspaceRole="reader"
    />
  );
}
